import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRiskPercentage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			width: 10,
			height: 10,
			rx: 3,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 12,
			width: 10,
			height: 10,
			rx: 3,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 12,
			width: 10,
			height: 10,
			rx: 3,
			fill: "#FF7875"
		})
	]
});
const ForwardRef = forwardRef(SvgRiskPercentage);
export { ForwardRef as ReactComponent };
